const mobileHeaderLanguagesSelector =
  document.querySelector('.header-mh-sp__locations') ??
  document.querySelector('.header-ey-sp__locations');
// const activeLanguageElement =
//   mobileHeaderLanguagesSelector.querySelector('[data-stt-active]') ??
//   document.querySelector('[data-stt-active]');
const activeLanguageElement =
  mobileHeaderLanguagesSelector?.querySelector('[data-stt-active]') ||
  document.querySelector('[data-stt-active]');

const languageJP = document.querySelector('[data-stt-changelang="ja"].location-link');
const languageEN = document.querySelector('[data-stt-changelang="en"].location-link');
const languageCN = document.querySelector('[data-stt-changelang="zh-CN"].location-link');
const languageTW = document.querySelector('[data-stt-changelang="zh-TW"].location-link');
const currentLanguageElement = document.getElementById('currentLanguage');
const LANGUAGE_MAPPINGS = {
  ja: '日',
  en: 'EN',
  'zh-CN': '簡',
  'zh-TW': '繁',
};
if (currentLanguageElement !== null) {
  const initialActiveLanguage = activeLanguageElement.getAttribute('data-stt-changelang');
  //window読み込み時に、初期の言語をcurrentLanguageにセット
  let currentLanguage = LANGUAGE_MAPPINGS[initialActiveLanguage];
  currentLanguageElement.innerText = currentLanguage;

  // 各language要素のクラス名の変更を検知し、変更後のクラス名にactiveが含まれてれば、その言語をcurrentLanguageにセット
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.getAttribute('data-stt-active') !== null) {
        const activatedLanguage = mutation.target.getAttribute('data-stt-changelang');
        currentLanguage = LANGUAGE_MAPPINGS[activatedLanguage];
        currentLanguageElement.innerText = currentLanguage;
      }
    });
  });
  observer.observe(languageJP, { attributes: true });
  observer.observe(languageEN, { attributes: true });
  observer.observe(languageCN, { attributes: true });
  observer.observe(languageTW, { attributes: true });
}
